import React, { Component } from 'react'
import Page from './Page'
import Step from './Step'
import { Button, ButtonLink, ButtonLinkExternal, Row } from '../generic'
import styled from 'styled-components'
import * as variables from '../../styles/variables'
import { CollapsiblePanel, Tip } from '../generic'
import WebMailHelper from './WebMailHelper'
import { Link } from 'react-router-dom'
import days from '../../helpers/countdown';
import facebookIcon from '../../images/facebook-light-filled.svg'
import twitterIcon from '../../images/twitter-light-filled.svg'
import instagramIcon from '../../images/instagram-light-filled.svg'
import ottHashtag from '../../images/ott-hashtag-black.png'

const HeaderSecondary = styled.h2`
  font-size: 25px;
  font-weight: bold;
  // margin-left: 20px;
  font-family: ${variables.fonts.body};
  &.primary {
    color: ${variables.colours.primary}
  }
  // .embiggen {
    // font-size: 32px;
  // }
`
const HeadingContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  h1 {
    margin-right: 20px;
  }
  // flex-align: baseline;
  // * {
  //   float: left;
  // }
`

const HorizontalRule = styled.hr`
  height: 1px;
  background: rgb(127, 127, 127);
  border: 0;
  margin: 30px 0;
`

const Section = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (max-width: ${variables.breakpoints.mobile}) {
    justify-content: center;
  }
`

const Warning = styled.div`
  color: ${variables.colours.orange};
  margin-bottom: 32px;
`

const ButtonLogoSmall = ButtonLinkExternal.extend`
  width: 32px;
  height: 32px;
  margin-right: 10px;
  padding: 0px;
  min-width: 0px;
  border-radius: 7px;
  background-color: transparent;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    
    border-radius: 100%;
    width: 32px;
    height: 32px;
  }

  img {
    width: 32px;
    height: 32px;
    border-radius: 5px;
    object-fit: cover;
  }
`

const HashtagImage = styled.img`
  display: block;
  margin-left: -12px;
  width: 155px;
  border-radius: 5px;
`

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMessageGuests: false,
    }
    this.props.getEvent().then(this.props.loadGuests)
    this.handleShowMessageGuests = this.handleShowMessageGuests.bind(this)
  }

  handleShowMessageGuests() {
    this.setState({
      showMessageGuests: !this.state.showMessageGuests
    })
  }

  render() {
    const { userEvent, currentUser, guests, onShare, onSurvey } = this.props

    let attendingGuests = [];
    if (guests && guests.length > 0) {
      attendingGuests = guests.filter((guest) => {return guest.status === 'yes';});
    }

    return (
      <Page {...this.props}>
        <HeadingContainer>
          <h1>Host Centre</h1>
          {days > 0 && <HeaderSecondary className="primary"><span className="embiggen">{days} {days > 1 ? 'days' : 'day'}</span> until On the Table</HeaderSecondary>}
        </HeadingContainer>
        <Tip id="dashboard-initial">
          <p>Welcome. The Host Centre provides tools and resources for creating a custom invitation, managing your guestlist, and sharing your experience.</p>
        </Tip>
        
        <div style={{ background: '#eee', padding: '10px 15px', borderRadius: '5px', display: 'flex', alignItems: 'center' }}>
          <h2 style={{ margin: '7px 18px 0px 0px' }}>Host Resources and Support</h2>
          <ButtonLinkExternal style={{ margin: 0 }} href="/resources/">Visit How to Host &rarr;</ButtonLinkExternal>
        </div>
      
        <h1 style={{marginTop: '30px'}}>Your On the Table Plan</h1>
        <p>You can return to any step after you complete it to change details.</p>
        <Section>
          <Step slug="profile" userEvent={userEvent} currentUser={currentUser}></Step>
          <Step slug="save-the-date" userEvent={userEvent} currentUser={currentUser}></Step>
          <Step slug="swag" userEvent={userEvent} currentUser={currentUser}></Step>
          <Step slug="event" userEvent={userEvent} currentUser={currentUser}></Step>
        </Section>
        <HorizontalRule />
        <h1>Your Guests</h1>
        <Section>
          <Step slug="how-to-invite" userEvent={userEvent} currentUser={currentUser}></Step>
          <Step slug="guests" userEvent={userEvent} currentUser={currentUser} guests={guests}></Step>
          <Step slug="reminder" userEvent={userEvent} currentUser={currentUser}></Step>
        </Section>

        <h2 style={{"marginTop": "32px"}}>Need to Cancel?</h2>
        <div>
          {userEvent && userEvent.cancelled && attendingGuests.length > 0 && <Warning>Your gathering is listed as cancelled, but you have received RSVPs. Be sure to message all guests to let them know about this change.</Warning>}
          <ButtonLink to={{ pathname: "/host/hub/forms/cancel", state: { modal: true } }}>{userEvent && userEvent.cancelled ? "Resume Event" : "Cancel Event"}</ButtonLink>
          {this.state.showMessageGuests && <div style={{"marginTop": "16px"}}><WebMailHelper event={userEvent} guests={attendingGuests} body="" /></div>}
        </div>

        <HorizontalRule />
        <h1>After The Event</h1>
        <Section>
          <Step slug="thank-you" userEvent={userEvent} currentUser={currentUser}></Step>
          <Step slug="share" userEvent={userEvent} currentUser={currentUser} onShare={onShare}></Step>
          {/*<Step slug="survey" userEvent={userEvent} currentUser={currentUser} onSurvey={onSurvey}></Step>*/}
        </Section>
      </Page>
    )
  }
}

export default Dashboard
